import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
import React from 'react';
import { RatingFormFacesArray } from './rating-form-faces-array';
import { RatingFormFacesLabel } from './rating-form-faces-label';

var RatingSelection = function RatingSelection(_ref) {
  var value = _ref.value,
      setValue = _ref.setValue,
      formType = _ref.formType;
  return /*#__PURE__*/_jsxs(x.div, {
    w: "100%",
    mt: "32px",
    children: [/*#__PURE__*/_jsx(RatingFormFacesArray, {
      value: value,
      setValue: setValue,
      formType: formType
    }), /*#__PURE__*/_jsx(RatingFormFacesLabel, {
      formType: formType
    })]
  });
};

export default RatingSelection;